import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

const topics: TopicItem[] = [
  {
    id: 'introduction',
    title: 'Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'What is a Database?', completed: true },
      { id: 'intro-2', title: 'SQL vs NoSQL', completed: false },
      { id: 'intro-3', title: 'Database Design Principles', completed: false },
    ],
  },
  {
    id: 'sql-fundamentals',
    title: 'SQL Fundamentals',
    completed: false,
    children: [
      { id: 'sql-basics', title: 'SQL Basics', completed: false },
      { id: 'queries', title: 'SELECT Queries', completed: false },
      { id: 'joins', title: 'JOINs', completed: false },
      { id: 'aggregations', title: 'Aggregations & Grouping', completed: false },
      { id: 'subqueries', title: 'Subqueries', completed: false },
    ],
  },
  {
    id: 'database-design',
    title: 'Database Design',
    completed: false,
    children: [
      { id: 'normalization', title: 'Normalization', completed: false },
      { id: 'relationships', title: 'Relationships', completed: false },
      { id: 'indexes', title: 'Indexes', completed: false },
      { id: 'transactions', title: 'Transactions', completed: false },
    ],
  },
  {
    id: 'nosql',
    title: 'NoSQL Databases',
    completed: false,
    children: [
      { id: 'mongodb', title: 'MongoDB', completed: false },
      { id: 'redis', title: 'Redis', completed: false },
      { id: 'cassandra', title: 'Cassandra', completed: false },
    ],
  },
];

const DatabasesPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="databases"
      topics={topics}
      title="Master Databases"
    />
  );
};

export default DatabasesPractice;
